export const REFERRALS_ENDPOINT = process.env.VUE_APP_REFERRALS_ENDPOINT
export const TRANSACTION_ENDPOINT = process.env.VUE_APP_TRANSACTION_ENDPOINT
export const LOGIN_ENDPOINT = process.env.VUE_APP_LOGIN_ENDPOINT
export const CHANGE_PASSWORD_ENDPOINT = process.env.VUE_APP_USER_CHANGE_PASSWORD_ENDPOINT
